import React from 'react';
import './Footer.css';
import { AnimatedSection } from '../AnimatedSection';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Top Call-to-Action Section */}
      <div className="footer-cta-container">
        {/* <div className="footer-cta">
          <div className="cta-content">
            <div className="cta-text">LET'S GET TO WORK.</div>
            <a href="https://form.typeform.com/to/LfUf3Jpc" target='_blank' className="cta-button">CONTACT US</a>
          </div>
        </div> */}

        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-container">
            {/* Three Columns */}
            <div className="footer-columns">
              {/* FOLLOW US Column */}
              <div className="footer-column">
                <h4 className="column-title">FOLLOW US</h4>
                <ul className="column-links">
                  <li><a href="https://www.instagram.com/game7?igsh=MWRiZmt1emV6Z3JjZQ==" target="_blank" rel="noopener noreferrer">INSTAGRAM</a></li>
                  <li><a href="https://x.com/game7" target="_blank" rel="noopener noreferrer">X</a></li>
                  <li><a href="https://www.youtube.com/@Game7Official" target="_blank" rel="noopener noreferrer">YOUTUBE</a></li>
                  <li><a href="https://www.tiktok.com/@game7official__" target="_blank" rel="noopener noreferrer">TIKTOK</a></li>
                  <li><a href="https://www.facebook.com/gamesevenoffical" target="_blank" rel="noopener noreferrer">FACEBOOK</a></li>
                </ul>
              </div>

              {/* OUR COMPANY Column */}
              <div className="footer-column-medium">
                {/* <h4 className="column-title">OUR COMPANY</h4> */}
                {/* <ul className="column-links">
                   <li><a href="#">ABOUT US</a></li>
                  <li><a href="#">THE TEAM</a></li>
                </ul> */}
              </div>

              {/* CONTACT Column */}
              <div className="footer-column-right">
                <h4 className="column-title">CONTACT</h4>
                <div className="contact-info">
                  <p>info@GAME7.com</p>
                </div>
              </div>
            </div>

            {/* Large GAME7 Logo */}
            <AnimatedSection>
            <div className="footer-logo">
              <img src="/home_data/section10/GAME 7.png" alt="GAME7" />
            </div>
            </AnimatedSection>
          </div>
        </div>

        {/* Bottom Copyright Section */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
            </div>
            <div className="legal-links">
              <a href="./document/privacy_policy.pdf" target='_blank'>Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
